import { api } from 'app/api'
import { OrgId } from 'app/common/types/id'

import {
  GET_BUILDINGS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/buildings/get'

export const getBuildings = async (params: { orgId: OrgId }, signal?: AbortSignal) => {
  const res = await api.request(GET_BUILDINGS, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные корпусов',
    params,
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res
}
